import { createAction, createReducer } from '@reduxjs/toolkit';
import { IAction, IPeriodo } from './interfaces/apiInterfaces';
import { IInitialState, ILastTwelveMonths } from './interfaces/reduxInterfaces';

const INITIAL_STATE: IInitialState = {
  isActive: false,
  isLoading: false,
  gotSuccess: false,
  gotError: false,

  dateSearch: {
    start: '',
    end: '',
  },
  slbPaid: {
    value: 0,
    quantity: 0,
  },
  lastTwelveMonths: [],
};

export const getSlbFaresFromApi = createAction(
  '@faresApp/slbFares/GET_SLB_FARES_FROM_API'
);

export const gotSlbFaresFromApi = createAction<any>(
  '@faresApp/slbFares/GOT_SLB_FARES_FROM_API'
);

export const gotErrorFromSlbFaresApi = createAction(
  '@faresApp/slbFares/GOT_ERROR_FROM_SLB_FARES_API'
);

export const displaySlbFares = createAction<boolean>(
  '@faresApp/slbFares/DISPLAY_SLB_FARES'
);

export const logoutSlbFaresApp = createAction(
  '@faresApp/slbFares/LOGOUT_SLB_FARES_APP'
);

const slbFaresReducer = createReducer(INITIAL_STATE, {
  [getSlbFaresFromApi.type]: (state) => ({
    ...state,
    isActive: false,
    isLoading: true,
    gotSuccess: false,
    gotError: false,
  }),
  [gotSlbFaresFromApi.type]: (state, action: IAction) => ({
    ...state,
    isActive: true,
    gotError: false,
    isLoading: false,
    dateSearch: {
      start: action.payload.data_pesquisa.de,
      end: action.payload.data_pesquisa.ate,
    },
    slbPaid: {
      value: action.payload.slb_pagas.valor,
      quantity: action.payload.slb_pagas.quantidade,
    },
    lastTwelveMonths: action.payload.periodo.map((mes: IPeriodo) => {
      const data: ILastTwelveMonths = {
        date: mes.data,
        faresReceived: {
          value: mes.slb_pagas.valor,
          quantity: mes.slb_pagas.quantidade,
        },
      };
      return data;
    }),
  }),
  [gotErrorFromSlbFaresApi.type]: (state: IInitialState) => ({
    ...state,
    isActive: false,
    isLoading: false,
    gotSuccess: false,
    gotError: true,
  }),
  [displaySlbFares.type]: (state: IInitialState, action) => ({
    ...state,
    isActive: action.payload,
  }),
  [logoutSlbFaresApp.type]: (state: IInitialState) => ({
    ...state,
    isActive: false,
    isLoading: false,
    gotSuccess: false,
    gotError: false,

    dateSearch: {
      start: '',
      end: '',
    },
    slbPaid: {
      value: 0,
      quantity: 0,
    },
    lastTwelveMonths: [],
  }),
});

export default slbFaresReducer;
